<!--
 * @Description: 潜在客户信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-06-28 11:19:25
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search" :model="form">
    <dc-layout-card :title="t('common.baseTabs')">
      <dc-form-item
        :name="['customerInfo', 'customerName']"
        :label="t('custom.customerName')"
        :rules="{
          message: t('common.pleaseInput'),
          required: true
        }"
      >
        <CosInput v-model:value="form.customerInfo.customerName" :maxlength="50" :view="formItemView" />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.customerNumber')"
        :name="['customerInfo', 'customerNumber']"
        :rules="
          perfect
            ? {
                message: t('common.pleaseSelect'),
                required: true
              }
            : []
        "
      >
        <SerialSelect
          v-model:value="form.customerInfo.customerNumber"
          :cosId="route.query.cosId"
          :view="formItemView"
          :requiredCosId="true"
          :disabled="!formItemView && !permissionBtn.includes(permissionPage.editCode) ? true : false"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.customerStatus')"
        :name="['customerInfo', 'status']"
        :rules="{
          message: t('common.pleaseSelect'),
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <div v-for="item in status" :key="item.value">
                <p>{{ item.label }}{{ item.descLang ? `：${t(item.descLang)}` : '' }}</p>
              </div>
            </template>
            <span>{{ t('custom.customerStatus') }}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSelect
          v-model:value="form.customerInfo.status"
          allowClear
          :disabled="disabled || type === 'clients'"
          :options="status"
          :view="formItemView"
        />
      </dc-form-item>
      <!--成交客户：档次和评级--->
      <template v-if="formItemView && type === 'clients'">
        <dc-form-item :label="t('custom.level')">
          <CosInput v-model:value="form.customerInfo.level" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('custom.clientsAmount')">
          <CosInputNumber
            v-model:value="form.customerInfo.turnoverAmount"
            :view="formItemView"
            cosType="money"
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          />
        </dc-form-item>
        <dc-form-item :label="t('custom.customerGrad')">
          <CosSelect v-model:value="form.customerInfo.grade" :options="dataConfig.customerGradeEnum" :view="formItemView" />
        </dc-form-item>
      </template>
      <dc-form-item
        :label="t('custom.channel')"
        :name="['customerInfo', 'channel']"
        :rules="{
          required: true,
          message: t('common.pleaseSelect')
        }"
      >
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="form.customerInfo.channel"
            appId="cos_ofbu"
            paramCode="ofbu_source_channel"
            :status="formItemView ? undefined : 0"
            :disabled="disabled"
            style="width: 33%"
            :view="formItemView"
            :cosDes="form.customerInfo.channelExplain"
          />
          <CosInput v-model:value="form.customerInfo.channelExplain" style="width: 67%" :view="formItemView" />
        </a-input-group>
      </dc-form-item>
      <dc-form-item
        :label="t('custom.customerOffice')"
        :name="['customerInfo', 'customerOffice']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <customer-area v-model:value="form.customerInfo.customerOffice" :view="formItemView" change-on-select />
      </dc-form-item>
      <dc-form-item
        :name="['customerInfo', 'customerWebsite']"
        :label="t('custom.officialWeb')"
        :rules="{
          message: t('common.pleaseInput'),
          required: true
        }"
      >
        <CosInput
          v-model:value.trim="form.customerInfo.customerWebsite"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item :name="['customerInfo', 'registerEmail']" :label="t('custom.regEmail')">
        <CosInput
          v-model:value.trim="form.customerInfo.registerEmail"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.customerAddress')"
        :name="['customerInfo', 'customerAddress']"
      >
        <CosInput
          v-model:value="form.customerInfo.customerAddress"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :name="['customerInfo', 'activityQrcodeId']"
        :label="t('custom.marketActivity')"
        :rules="[{ required: marketRequired, message: t('common.pleaseSelect') }]">
        <CosSelect
          v-model:value="form.customerInfo.activityQrcodeId"
          :options="marketOptions"
          :disabled="disabled"
          :view="formItemView"
          optionFilterProp="label"
          showSearch
        />
      </dc-form-item>
      <dc-form-item name="customerRegion" :label="t('custom.customerRegion')">
        <CustomerAreaCascader
          appId="cos_ofbu"
          v-model:value="form.customerInfo.customerRegion"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="6" v-if="!formItemView">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('custom.estAveRevenue')"
            :name="['business', 'annualSales']"
            :rules="{ message: t('common.pleaseInput'),required: true }"
          >
            <CosInputNumber
              v-model:value="form.business.annualSales"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="formItemView"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="annualSalesUnit"
            style="width: 30%"
            :name="['business', 'annualSalesUnit']"
            class="hide-label"
            :rules="{ message: t('common.pleaseSelect'),required: true }"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="form.business.annualSalesUnit"
              :view="formItemView"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('custom.estAveRevenue')"
        :name="['business', 'annualSalesUnit']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          :cosBeforeDes="form.business?.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="form.business.annualSalesUnit"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.clientType')"
        :name="['customerInfo', 'clientType']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          :options="paramCodeData.ofbu_client_type"
          v-model:value="form.customerInfo.clientType"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.salesChannel')"
        :name="['business', 'salesChannel']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.ofbu_sales_channel"
          v-model:value="form.business.salesChannel"
          :view="formItemView"
        />
      </dc-form-item>
      <template v-if="formItemView">
        <dc-form-item :label="t('custom.remanentFollowDayType')">
          <CosInput v-model:value="form.customerInfo.remanentFollowDays" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('custom.followerName')">
          <CosInput v-model:value="form.customerInfo.sellerName" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('common.createByName')">
          <CosInput v-model:value="form.customerInfo.createByName" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('custom.cosId')">
          <CosInput v-model:value="form.customerInfo.cosId" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('custom.turnedContractTime')" v-if="form.customerInfo.status > 19">
          <CosInput v-model:value="form.customerInfo.turnedContract" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('custom.turnedPotentialTime')" v-if="form.customerInfo.status > 29">
          <CosInput v-model:value="form.customerInfo.turnedTransaction" :view="formItemView" />
        </dc-form-item>
      </template>
      <template v-if="formItemView">
        <dc-form-item :label="t('common.createTime')">
          <CosInput v-model:value="form.customerInfo.createTime" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('custom.lastReceiveTime')">
          <CosInput v-model:value="form.customerInfo.lastReceiveTime" :view="formItemView" />
        </dc-form-item>
        <dc-form-item :label="t('custom.turnedPotentialTime')">
          <CosInput v-model:value="form.customerInfo.turnedPotential" :view="formItemView" /> </dc-form-item
      ></template>
    </dc-layout-card>
    <dc-layout-card :title="t('custom.concatTitle')">
      <!-- <dc-form-item :label="t('common.contactName')" :name="['contact', 'name']">
        <CosInput v-model:value="form.contact.name" :view="formItemView" :maxlength="50" />
      </dc-form-item> -->
      <dc-form-item
        v-if="formItemView"
        :label="t('common.contactName')"
        :name="['contact', 'lastName']"
        :rules="[
          {
            message: t('common.pleaseInput'),
            required: true
          },
          {
            validator: concatNameValidate
          }
        ]"
      >
        <CosInput v-model:value="form.contact.name" :view="formItemView" />
      </dc-form-item>
      <a-col v-else :span="6">
        <div class="flex cos-both-form-item">
          <a-form-item :span="24" :label="t('common.firstName')" style="width: 50%">
            <CosInput v-model:value="form.contact.firstName" :maxlength="50" />
          </a-form-item>
          <a-form-item
            :label="t('common.lastName')"
            :name="['contact', 'lastName']"
            style="width: 50%"
            class="last-compact"
            :rules="[
              {
                message: t('common.pleaseInput'),
                required: true
              },
              {
                validator: concatNameValidate
              }
            ]"
          >
            <CosInput v-model:value="form.contact.lastName" :maxlength="50" />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item :label="t('common.mobile')" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodesSelect
            :options="paramCodeData.ofbu_area_code"
            v-model:value="form.contact.mobileRegion"
            :view="formItemView"
            :cosDes="form.contact.mobile"
            style="width: 33%"
          />
          <dc-form-item
            :span="24"
            style="width: 67%"
            class="last-compact"
            :name="['contact', 'mobile']"
            :rules="{
              validator: (rule, value) => ofbuContactValidate(rule, value, form.contact, formRef)
            }"
          >
            <CosInput v-model:value="form.contact.mobile" :view="formItemView" />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'skype']"
        :label="t('common.skype')"
        :rules="{
          validator: (rule, value) => ofbuContactValidate(rule, value, form.contact, formRef)
        }"
      >
        <CosInput v-model:value="form.contact.skype" :view="formItemView" />
      </dc-form-item>
      <dc-form-item
        :name="['contact', 'email']"
        :label="t('common.email')"
        :rules="[
          {
            validator: (rule, value) => ofbuContactValidate(rule, value, form.contact, formRef)
          }
        ]"
      >
        <CosInput v-model:value="form.contact.email" :view="formItemView" />
      </dc-form-item>
      <dc-form-item :label="t('common.jobRole')">
        <CosSelect
          v-model:value="form.contact.jobRole"
          :options="dataConfig.linkRoleTypeEnum"
          allow-clear
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item :label="t('common.jobDuty')">
        <CosInput v-model:value="form.contact.jobDuty" :view="formItemView" :maxlength="50" />
      </dc-form-item>
      <dc-form-item :label="t('common.sex')">
        <CosRadioGroup v-model:value="form.contact.sex" :view="formItemView" :options="dataConfig.genderEnum" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item :label="t('common.contactRemark')" :span="12">
        <CosTextarea v-model:value="form.contact.remark" :maxlength="2000" :view="formItemView" />
      </dc-form-item>
      <a-col :span="6" />
    </dc-layout-card>
    <dc-layout-card :title="t('custom.业务需求')">
      <dc-form-item
        :label="t('custom.业务类型')"
        :name="['business', 'businessTypeSelect']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.businessTypeSelect"
          :options="paramCodeData.ofbu_business_type"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.服务标准')"
        :name="['business',  'servicesStandard']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.servicesStandard"
          :options="paramCodeData.ofbu_services_standard"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.销售平台')"
        :name="['business', 'salePlatform']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.salePlatform"
          :options="paramCodeData.ofbu_sale_platform"
          :disabled="disabled"
          :view="formItemView"
          allowClear
          mode="multiple"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.发货量(月)')"
        :name="['business',  'shipments']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.shipments"
          :options="paramCodeData.ofbu_shipments"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.产品分类')"
        :name="['business', 'salesCategory']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.ofbu_sales_category"
          v-model:value="form.business.salesCategory"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.产品尺寸')"
        :name="['business', 'cargoType']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          mode="multiple"
          :options="paramCodeData.ofbu_product_type"
          v-model:value="form.business.cargoType"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'orderTypeDistribution']"
        :label="t('custom.订单类型分布')"
        :rules="{
          message: t('common.pleaseInput'),
          required: true
        }"
      >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('common.订单类型分布输入提示')}}</p>
            </template>
            <span>{{t('custom.订单类型分布')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value.trim="form.business.orderTypeDistribution"
          :maxlength="200"
          :disabled="disabled"
          :placeholder="t('common.订单类型分布输入提示')"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'productValue']" :label="t('custom.热销品价值(USD)')">
        <CosInput
          v-model:value.trim="form.business.productValue"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'orderDistribution']"
        :label="t('custom.单品多品订单比例')"
        :rules="{
          message: t('common.pleaseInput'),
          required: true
        }"
      >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('common.单品多品订单比例输入提示')}}</p>
            </template>
            <span>{{t('custom.单品多品订单比例')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput
          v-model:value.trim="form.business.orderDistribution"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
          :placeholder="t('common.单品多品订单比例输入提示')"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'skuType']"
        :label="t('custom.SKU种类')"
        :rules="{
          message: t('common.pleaseInput'),
          required: true
        }"
      >
        <CosInput
          v-model:value.trim="form.business.skuType"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.SKU单位')"
        :name="['business', 'skuUnit']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.skuUnit"
          :options="paramCodeData.ofbu_sku_unit"
          :disabled="disabled"
          :view="formItemView"
          allowClear
          mode="multiple"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.尾程服务需求')"
        :name="['business', 'serviceType']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.serviceType"
          :options="paramCodeData.ofbu_service_type"
          :disabled="disabled"
          :view="formItemView"
          allowClear
          mode="multiple"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.区域仓')"
        :name="['business', 'regionalWarehouse']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.regionalWarehouse"
          :options="paramCodeData.ofbu_demand_info"
          :disabled="disabled"
          :view="formItemView"
          allowClear
          mode="multiple"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.入库包装方式')"
        :name="['business', 'inboundPackageType']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.inboundPackageType"
          :options="paramCodeData.ofbu_inbound_package_type"
          :disabled="disabled"
          :view="formItemView"
          allowClear
          mode="multiple"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'averageInventoryVolume']"
        :label="t('custom.平均在库体积')"
        :rules="{
          message: t('common.pleaseInput'),
          required: true
        }"
      >
        <CosInput
          v-model:value.trim="form.business.averageInventoryVolume"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'firstInboundTime']"
        :label="t('custom.预计第一次来货时间')"
        :rules="{
          message: t('common.pleaseSelect'),
          required: true
        }"
      >
        <CosSingleDateTimePicker
          isOutputBeijingTime
          v-model:startTime="form.business.firstInboundTime"
          :isRange="false"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'futureIncrement']" :label="t('custom.未来增量(月订单)')">
        <CosInput
          v-model:value.trim="form.business.futureIncrement"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item :name="['business', 'systemIntegration']" :label="t('custom.系统对接需求')">
        <CosInput
          v-model:value.trim="form.business.systemIntegration"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
          :placeholder="t('common.系统对接需求输入提示')"
        />
      </dc-form-item>
      <dc-form-item :label="t('custom.其他附件')" name="otherFile" :span="24">
        <UploadFile :view="formItemView" v-model:value="form.business.otherFile" valueType="array" />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card :title="t('custom.报价')" :span="6">
      <template #subTitle v-if="!formItemView&&quotationAndBusinessChange">
        <a-button type="primary" ghost @click="handleAddCol(form.business.quotationInfo.details)">{{ t('btn.add') }}</a-button>
      </template>
      <dc-form-item
        :label="t('custom.价格类型')"
        :name="['business', 'quotationInfo', 'quotationType']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: props.type !== 'potential'
        }"
      >
        <ParamCodesSelect
          v-model:value="form.business.quotationInfo.quotationType"
          :options="paramCodeData.ofbu_quotation_type"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        v-if="quotationAndBusinessChange"
        :name="['business', 'quotationInfo', 'fulfillmentRatesVersion']"
        :label="t('custom.仓储报价版本')"
        :rules="{
              message: t('common.pleaseInput'),
              required: props.type !== 'potential' && quotationAndBusinessChange
            }"
      >
        <CosInput
          v-model:value.trim="form.business.quotationInfo.fulfillmentRatesVersion"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        v-if="quotationAndBusinessChange"
        :name="['business', 'quotationInfo', 'shippingRatesVersion']"
        :label="t('custom.尾程报价版本')"
        :rules="{
              message: t('common.pleaseInput'),
              required: props.type !== 'potential' && quotationAndBusinessChange
            }"
      >
        <CosInput
          v-model:value.trim="form.business.quotationInfo.shippingRatesVersion"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <!-- 当【价格类型】选择为【定制价 id3469】时，显示该字段并必填 -->
      <!-- 公布价 id3468 -->
      <dc-form-item
        v-if="form.business.quotationInfo.quotationType === 3469"
        :name="['business', 'quotationInfo', 'priceDocuments']"
        :label="t('custom.报价策略')"
        :rules="{ required: form.business.quotationInfo.quotationType === 3469, message: t('common.pleaseInput') }"
      >
        <CosInput
          v-model:value.trim="form.business.quotationInfo.priceDocuments"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <MultipleItem :view="formItemView" v-if="quotationAndBusinessChange">
        <template v-for="(item, index) in form.business.quotationInfo.details" :key="index">
          <a-col :span="24">
            <p style="font-weight: bold;padding-bottom:4px">{{ `${t('custom.区域仓')}${index+1}` }}</p>
          </a-col>
          <dc-form-item
            :label="t('custom.区域仓')"
            :span="3"
            :name="['business', 'quotationInfo', 'details', index, 'regionalWarehouse']"
          >
            <ParamCodesSelect
              v-model:value="item.regionalWarehouse"
              :options="paramCodeData.ofbu_demand_info"
              :disabled="disabled"
              :view="formItemView"
              allowClear
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'subWarehouseCode']" :label="t('custom.物理仓')" :span="3">
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>Warehouse Management Team will confirm in OA</p>
                </template>
                <span>{{t('custom.物理仓')}}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
              </a-tooltip>
            </template>
            <CosInput
              v-model:value.trim="item.subWarehouseCode"
              :maxlength="200"
              ignorePlaceHolder
              disabled
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'storageFeeDiscount']" :label="t('custom.仓租折扣(%)')" :span="3">
            <CosInput
              v-model:value.trim="item.storageFeeDiscount"
              :maxlength="200"
              :disabled="disabled"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'handingFeeDiscount']" :label="t('custom.操作费折扣(%)')" :span="3">
            <CosInput
              v-model:value.trim="item.handingFeeDiscount"
              :maxlength="200"
              :disabled="disabled"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'shippingFeeDiscount']" :label="t('custom.尾程折扣(%)')" :span="3">
            <CosInput
              v-model:value.trim="item.shippingFeeDiscount"
              :maxlength="200"
              :disabled="disabled"
              :view="formItemView"
            />
          </dc-form-item>
          <dc-form-item :name="['business', 'quotationInfo', 'details', index, 'remark']" :label="t('common.remark')" :span="6">
              <CosInput
                v-model:value="item.remark"
                :maxlength="2000"
                :disabled="disabled"
                :view="formItemView"
              />
          </dc-form-item>
          <dc-form-item v-if="
                 !formItemView &&
                  form.business.quotationInfo.details &&
                  form.business.quotationInfo.details.length > 1
                " :span="3">
            <a-button
              type="text"
              danger
              style="padding: 0 0 0 12px"
              @click="handleDelCol(form.business.quotationInfo.details,index)"
            >{{ t('btn.del') }}</a-button
            >
          </dc-form-item>
        </template>
      </MultipleItem>
      <dc-form-item :label="t('custom.客户报价/竞对报价')" :name="['business', 'quotationInfo', 'competitorPriceDocuments']" :span="24">
        <UploadFile :view="formItemView" v-model:value="form.business.quotationInfo.competitorPriceDocuments" valueType="array" />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card :title="t('custom.合同和账期')" :span="6">
      <dc-form-item
        :label="t('custom.服务公司')"
        :name="['business', 'contractInfo', 'serviceCompany']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: props.type !== 'potential'
            }"
      >
        <ParamCodesSelect
          v-model:value="form.business.contractInfo.serviceCompany"
          :options="paramCodeData.ofbu_service_body"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.付款方式')"
        :name="['business', 'contractInfo', 'paymentType']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: props.type !== 'potential'
            }"
      >
        <ParamCodesSelect
          v-model:value="form.business.contractInfo.paymentType"
          :options="paramCodeData.ofbu_payment_type"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.出账周期(天)')"
        :name="['business', 'contractInfo', 'billingTerm']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: props.type !== 'potential'
            }"
      >
        <ParamCodesSelect
          v-model:value="form.business.contractInfo.billingTerm"
          :options="paramCodeData.ofbu_billing_term"
          :disabled="disabled"
          :view="formItemView"
          allowClear
        />
      </dc-form-item>
      <!-- 当【付款方式】选择为【额度 3504】时，显示该字段，非必填,当【付款方式】选择为【账期 3473】时，显示该字段，且必填 -->
      <dc-form-item
        v-if="form.business.contractInfo.paymentType === 3504
         || form.business.contractInfo.paymentType === 3473"
        :name="['business', 'contractInfo', 'paymentTerm']"
        :label="t('custom.付款周期(天)')"
        :rules="{
              message: t('common.pleaseInput'),
              required: form.business.contractInfo.paymentType === 3473
            }"
      >
        <CosInput
          v-model:value.trim="form.business.contractInfo.paymentTerm"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="6" v-if="!formItemView && form.business.contractInfo.paymentType === 3504">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('custom.固定额度')"
            :name="['business', 'contractInfo', 'fixedCredit', 'amount']"
            :rules="{
              message: t('common.pleaseInput'),
              required: true
            }"
          >
            <CosInputNumber
              v-model:value="form.business.contractInfo.fixedCredit.amount"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="formItemView"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="fixedCreditCurrency"
            style="width: 30%"
            :name="['business', 'contractInfo', 'fixedCredit', 'currency']"
            class="hide-label"
            :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="form.business.contractInfo.fixedCredit.currency"
              :view="formItemView"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-if="formItemView && form.business.contractInfo.paymentType === 3504"
        :label="t('custom.固定额度')"
        :name="['business', 'contractInfo', 'fixedCredit', 'currency']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: true
            }"
      >
        <ParamCodesSelect
          :cosBeforeDes="form.business.contractInfo.fixedCredit.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="form.business.contractInfo.fixedCredit.currency"
          :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="6" v-if="!formItemView">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('custom.系统注册费')"
            :name="['business', 'contractInfo', 'registrationFee', 'amount']"
            :rules="{
              message: t('common.pleaseInput'),
              required: props.type !== 'potential'
            }"
          >
            <CosInputNumber
              v-model:value="form.business.contractInfo.registrationFee.amount"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="formItemView"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="registrationFeeCurrency"
            style="width: 30%"
            :name="['business', 'contractInfo', 'registrationFee', 'currency' ]"
            class="hide-label"
            :rules="{
              message: t('common.pleaseSelect'),
              required: props.type !== 'potential'
            }"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="form.business.contractInfo.registrationFee.currency"
              :view="formItemView"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('custom.系统注册费')"
        :name="['business', 'contractInfo', 'registrationFee', 'currency']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: props.type !== 'potential'
        }"
      >
        <ParamCodesSelect
          :cosBeforeDes="form.business.contractInfo.registrationFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="form.business.contractInfo.registrationFee.currency"
          :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="6" v-if="!formItemView">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('custom.系统管理月费')"
            :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'amount']"
            :rules="{
              message: t('common.pleaseInput'),
              required: props.type !== 'potential'
            }"
          >
            <CosInputNumber
              v-model:value="form.business.contractInfo.monthlyMaintenanceFee.amount"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="formItemView"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="monthlyMaintenanceFeeCurrency"
            style="width: 30%"
            :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency']"
            class="hide-label"
            :rules="{
              message: t('common.pleaseSelect'),
              required: props.type !== 'potential'
            }"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="form.business.contractInfo.monthlyMaintenanceFee.currency"
              :view="formItemView"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('clue.系统管理月费')"
        :name="['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency']"
        :rules="{
          message: t('common.pleaseSelect'),
          required: props.type !== 'potential'
        }"
      >
        <ParamCodesSelect
          :cosBeforeDes="form.business.contractInfo.monthlyMaintenanceFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="form.business.contractInfo.monthlyMaintenanceFee.currency"
          :view="formItemView"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('custom.客户特殊服务')"
        :name="['business', 'contractInfo', 'additionalServices']"
        :rules="{
              message: t('common.pleaseSelect'),
              required: props.type !== 'potential'
            }"
      >
        <ParamCodesSelect
          v-model:value="form.business.contractInfo.additionalServices"
          :options="paramCodeData.ofbu_service_demand"
          :disabled="disabled"
          :view="formItemView"
          allowClear
          mode="multiple"
        />
      </dc-form-item>
      <dc-form-item
        :name="['business', 'contractInfo', 'legalSystemApplicationNo']"
        :label="t('custom.法务流程编码')"
        :rules="{
              message: t('common.pleaseSelect'),
              required: props.type !== 'potential'
            }">
        <CosInput
          v-model:value.trim="form.business.contractInfo.legalSystemApplicationNo"
          :maxlength="200"
          :disabled="disabled"
          :view="formItemView"
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item :label="t('common.remark')" :span="12">
        <CosTextarea v-model:value="form.customerInfo.remark" :maxlength="2000" :view="formItemView" />
      </dc-form-item>
    </dc-layout-card>
  </a-form>
  <cos-footer-button
    v-if="!disabled"
    v-model:value="form"
    :resetValue="resetValue"
    :formRef="formRef"
    :loading="loading"
    @submit="handleSubmit"
    :disabled="disabled"
    :permissionPage="permissionPage"
  >
  </cos-footer-button>
</template>
<script setup lang="ts">
import { computed, onMounted, watch, ref, PropType, reactive } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import CustomerArea from '@/components/CustomerArea/index'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import SerialSelect from './serialSelect.vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { potentialAdd, potentialEdit } from '@/api/overseasSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { goBack } from '@/hooks/cosRouter'
import { usePermissionStore } from '@/stores/permission'
import { ofbuContactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
import calc from '@/utils/calc'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'
const { t } = useI18n()
const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const route = useRoute()
const initForm = reactive<any>({
  business: {
    businessType: [],
    saleInfo: [{}],
    demandInfo: {
      warehouses: [{}]
    },
    erpInfo: [{}],
    replenish: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  contact: {},
  customerInfo: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const loading = ref(false)
const form = ref<any>(cloneDeep(initForm))
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<PotentialItem>,
    default: () => {
      return {
        business: {},
        contact: {}
      }
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  formItemView: {
    type: Boolean
  },
  type: {
    type: String,
    default: 'potential' // 潜在，contract 签约，clients 成交的基本信息
  },
  perfect: {
    type: Boolean,
    default: false
  },
  hideOk: {
    type: Boolean
  }
})
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      const formVal = v
      initObjectVal(formVal, initForm)
      form.value = cloneDeep(formVal)
      resetValue.value = cloneDeep(formVal)
    }
  },
  { immediate: true }
)
const quotationAndBusinessChange = ref<boolean>(false)
// 当【价格类型】选择为【公布价】且【业务类型】选择为【仓储服务】或【头程+仓储】时
watch(
  () => [form.value.business.quotationInfo.quotationType, form.value.business.businessTypeSelect],
  (newValue, oldValue) => {
    const [quotationType, businessTypeSelect] = newValue
    quotationAndBusinessChange.value = (quotationType === 3468) &&
      (businessTypeSelect === 3438 || businessTypeSelect === 3441)
  },
  { immediate: true, deep: true }
)
watch(
  () => form.value.business.contractInfo?.paymentType,
  (newValue, oldValue) => {
    if (newValue === 3504 || newValue === 3473) {
      if (!form.value.business.contractInfo.paymentTerm) {
        form.value.business.contractInfo.paymentTerm = '10'
      }
    }
  },
  { immediate: true, deep: true }
)
const formRef = ref()
const marketRequired = ref<boolean>()
const marketOptions = ref<any[]>([])
const status = computed(() => {
  // 如果是签约客户编辑，不能选择终止合作
  if (route.path.includes('/ofbu/contract/edit')) {
    return cloneDeep(dataConfig.contractStatusEnum).map((item: any) => {
      if (item.value === 22) {
        item.disabled = true
      }
      return item
    })
  }
  if (props.type === 'potential') {
    return dataConfig.potentialStatusEnum
  } else if (props.type === 'contract') {
    return dataConfig.contractStatusEnum
  } else if (props.type === 'clients') {
    return dataConfig.clientsStatusEnum
  }
  return []
})
watch(
  () => form.value.customerInfo?.channel,
  (val) => {
    // 目前当【线索来源】选择【市场活动、市场投放、市场渠道（合作伙伴）】时，关联市场该字段必填
    // 但是线索来源是属于层级的，该三个来源下还有一层，无法全部判断，故此处就只判断非必填的状态
    // 非必填：内部推荐1812 销售开发1813
    if (val) {
      marketRequired.value = !(val === 1812 || val === 1813)
    } else {
      marketRequired.value = false
    }
  },
  { immediate: true }
)
const paramCodeData = ref<any>({
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 货物类型
  ofbu_warehouse: [], // 合作海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_service_demand: [], // 服务需求
  ofbu_demand_info: [], // 需求海外仓
  ofbu_inbound_package_type: [], // 入库包装方式
  ofbu_erp_info: [], // 目前使用ERP
  ofbu_replenish_frequency: [], // 头程补货频次
  ofbu_business_type: [], // 客户业务类型
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_head_replenish_method: [], // 头程补货方式
  ofbu_area_code: [], // 电话区号
  ofbu_customer_size: [], // 客户规模
  ofbu_currency: [], // 币种
  ofbu_shipments: [], // 发货量
  ofbu_sku_unit: [], // SKU单位
  ofbu_quotation_type: [], // 价格类型
  ofbu_service_type: [], // 尾程服务需求
  ofbu_service_body: [], // 服务主体（服务公司）
  ofbu_payment_type: [], // 付款方式
  ofbu_client_type: [], // 客户类型
  ofbu_sales_channel: [], // 销售渠道
  ofbu_services_standard: [], // 服务标准
  ofbu_billing_term: [] // 出账周期
})
const percentValidate = async (rule: Rule, value: string) => {
  const result = form.value.business.saleInfo.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
    0
  )
  if (value && result !== 100) {
    return Promise.reject(new Error(t('custom.saleInfoPercentValidate')))
  } else {
    return Promise.resolve()
  }
}
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_warehouse',
      'ofbu_sale_platform',
      'ofbu_service_demand',
      'ofbu_demand_info',
      'ofbu_inbound_package_type',
      'ofbu_erp_info',
      'ofbu_replenish_frequency',
      'ofbu_business_type',
      'ofbu_marketing_activity',
      'ofbu_head_replenish_method',
      'ofbu_area_code',
      'ofbu_customer_size',
      'ofbu_sign_in_address_label',
      'ofbu_currency',
      'ofbu_shipments',
      'ofbu_sku_unit',
      'ofbu_quotation_type',
      'ofbu_service_type',
      'ofbu_service_body',
      'ofbu_payment_type',
      'ofbu_client_type',
      'ofbu_sales_channel',
      'ofbu_services_standard',
      'ofbu_billing_term'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
onMounted(() => {
  getByParamCodes()
  getMarketOption()
})
// 海外仓月销售额
const amount = computed(() => {
  const result = form.value.business.demandInfo.warehouses.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.amount) || 0),
    0
  )
  return result || 0
})
// 去除数组null ''
const clear = (arr: any[], keys: string[]) => {
  if (!arr) {
    return []
  }
  let result: any = []
  arr.forEach((v: any) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (v[k] != null && v[k] !== '') {
        result.push(v)
        break
      }
    }
  })
  if (!result.length) {
    result = [{}]
  }
  return result
}
const handleSubmit = async () => {
  loading.value = true
  const p = cloneDeep(form.value)
  const { replenish, erpInfo, demandInfo, saleInfo } = p.business
  // 地址为空清除、判断地址是否重复
  // if (checkAddressData(form.value.visitAddress)) {
  //   message.error('签到地址不可重复！')
  //   loading.value = false
  //   return false
  // }
  const { visitAddress } = p
  p.visitAddress = clear(visitAddress, ['addressName'])
  // 新增、编辑的格式和详情不同、多传attrList
  if (JSON.stringify(p.visitAddress) === '[{}]') {
    p.visitAddress = { attrList: [] }
  } else {
    p.visitAddress = { attrList: p.visitAddress }
  }
  if (p.business) {
    p.business.replenish = clear(replenish, ['replenishId', 'frequency', 'replenishment'])
    p.business.erpInfo = clear(erpInfo, ['erpId', 'erpAccount'])
    p.business.saleInfo = clear(saleInfo, ['salePlatformId', 'percent'])
    if (demandInfo && demandInfo.warehouses) {
      p.business.demandInfo.warehouses = clear(demandInfo.warehouses, ['warehouseId', 'amount'])
    }
    // 清空产业带名称
    if (p.business.industrialBeltFlag !== 1) {
      p.business.industrialBeltName = ''
    }
    if (p.business.businessTypeSelect) {
      p.business.businessType = [p.business.businessTypeSelect]
      p.business.businessTypeSelect = undefined
    }
  }
  try {
    if (route.query.cosId) {
      await potentialEdit(p)
      message.success(t('tips.editSuccess'))
    } else {
      await potentialAdd(p)
      message.success(t('tips.addSuccess'))
    }
    goBack()
  } catch (error) {}
  loading.value = false
}

// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}
</script>
<script lang="ts">
export default { name: 'customerCenterBaseMessage' }
</script>
